import styled from 'styled-components'

type ActiveProps = {
  $active?:boolean,
  $noMargin?:boolean
}
type ContainerProp = {
  customStyles?:any,
  $hasTitle?:boolean,
}

export const Container = styled.div<ContainerProp>`
  display: flex;
  align-items: flex-start;
  min-width: 0;
  ${({customStyles}) => customStyles}

  > div {
    min-width: 0;
  }

  @media (max-width: 768px) {
    width: ${({$hasTitle}) => $hasTitle ? '100%' : 'auto'};
    max-width: ${({$hasTitle}) => $hasTitle ? '100%' : 'none'};
    flex-shrink: 0;
  }
`

export const StyledToggle = styled.button<ActiveProps>`
  appearance: none;
  box-sizing: border-box;
  padding: 2px;
  width: 50px;
  min-width: 50px;
  height: 24px;
  flex: 0 0 50px;
  border-radius: 20px;
  margin-right: ${({$noMargin}) => $noMargin ? '0px' : '10px'};
  background-color: ${({theme, $active}) => $active ? theme.accent[100] : theme.grey[300]};
  border: 0;
  &:hover:not(:disabled){
    cursor: pointer;
  }
  &:disabled{
    background-color: ${({theme}) => theme.grey[200]};
    cursor: not-allowed;
  }
  &:focus-visible{
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const DotPoint = styled.div<ActiveProps>`
  transition-duration: 500ms;
  transform:${({$active}) => $active ? 'translate(26px)' : ''};
  width: 20px;
  height: 20px;
  box-shadow: ${({theme}) => theme.shadows.control};
  background-color: ${({theme}) => theme.base.white};
  border-radius: 100%;
  animation: 0.5ms;

  ${StyledToggle}:disabled & {
    background-color: ${({theme}) => theme.grey[100]};
  }
`
export const ToolTipImg = styled.img`
  margin-left:'6px';
  &:hover{
    cursor: pointer;
  }
`
